import React, { useContext } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { BsFillBookmarkFill, BsThreeDots } from "react-icons/bs";
import { AiFillStar } from "react-icons/ai";
import { FiLock } from "react-icons/fi";
import { TbMathGreater, TbMathLower } from "react-icons/tb";
// @ts-ignore
import Bulb from "../../Assets/Images/Sat-images/Isolation_Mode.webp";
// @ts-ignore
import download from "../../Assets/Images/Sat-images/download-icon.webp";
// @ts-ignore
import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
// @ts-ignore
import SatNavbar from "../../screens/SatCourse/CoursesScreen";
// @ts-ignore
import UserContext from "../../utils/UserContext";

// pdfjs initialization
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export interface ContentProps {
  isError: boolean;
  innerWidth: number;
  HandleBookMark: (id: string | number) => void;
  HandleDeleteBookMark: (id: string | number) => void;
  data: any[];
  HandleNavigate: () => void;
  chapterName: string;
  isNavigateBookmark: boolean;
  onDocumentLoadSuccess: (numPages: number) => void;
  noOfPages: number[];
  HandleNextpdf: (id: string | number) => void;
  HandlePreviousPdf: () => void;
  handleScroll: (e: any) => void;
  currentIndex: number;
  checkPrevious: boolean;
  downloadFile: (url: string) => void;
  courseTitle: string;
  HandleSatNavBarResp: () => void;
  chaptersCurrentIndex: number;
  chapterTitle: string;
  chapterCompleted: boolean;
}

const Content: React.FC<ContentProps> = (props) => {
  const { checkSatNavbar, satCourseData, satChapters } = useContext<any>(UserContext);

  return (
    <>
      <div className="Home-Container">
        {props?.isError ? (
          <h1 className="is-error">Error loading content</h1>
        ) : (
          <div className="home-sub-container">
            {window.innerWidth < 1024 ? (
              <>{checkSatNavbar ? <SatNavbar /> : ""}</>
            ) : (
              <div className="cp-Navbar-container">
                <SatNavbar />
              </div>
            )}
            <div className="main-right-container">
              <div className="content-main-container">
                <div className="content-sub-container">
                  <div className="content-first-section">
                    <div
                      className="bs-content-arrow-left"
                      onClick={props.HandleNavigate}
                    >
                      <BsArrowLeft size="20px" />
                    </div>
                    {props.innerWidth < 1024 ? (
                      <>
                        <div
                          className="content-bookmark"
                          onClick={() => {
                            props?.data[props?.currentIndex]?.isBookmarked
                              ? props.HandleDeleteBookMark(
                                  props?.data[props?.currentIndex]?.id
                                )
                              : props.HandleBookMark(
                                  props?.data[props?.currentIndex]?.id
                                );
                          }}
                        >
                          <BsFillBookmarkFill
                            size="20px"
                            color={
                              props?.data[props?.currentIndex]?.isBookmarked
                                ? "#A20107"
                                : "#C7C7C7"
                            }
                          />
                        </div>
                        <div className="Icon-panel-st">
                          <div
                            className="icon-st"
                            onClick={() => {
                              props.HandleSatNavBarResp();
                            }}
                          >
                            <BsThreeDots size="20" />
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="content-second-section ">
                        <div className="content-second-sub-container">
                          <div
                            className="content-icon"
                            onClick={() => {
                              props?.data[props?.currentIndex]?.isBookmarked
                                ? props.HandleDeleteBookMark(
                                    props?.data[props.currentIndex]?.id
                                  )
                                : props.HandleBookMark(
                                    props?.data[props.currentIndex]?.id
                                  );
                            }}
                          >
                            <BsFillBookmarkFill
                              size="15px"
                              color={
                                props?.data[props?.currentIndex]?.isBookmarked
                                  ? "#A20107"
                                  : "#C7C7C7"
                              }
                            />
                          </div>

                          {props.isNavigateBookmark ? (
                            ""
                          ) : (
                            <div className="content-buttons-panel">
                              <div>
                                {props?.chapterCompleted ? (
                                  <div className="content-chk-chapter">
                                    {" "}
                                    <div className="list-item-id-panel m-l">
                                      <FiLock size="15px" color="#ffff" />
                                    </div>
                                    <div className="discription-content">
                                      Next chapter will be unlock after 12 AM.
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div
                                className={
                                  props?.currentIndex === 0 ||
                                  props?.checkPrevious
                                    ? "previous-content disable-div"
                                    : "previous-content"
                                }
                                onClick={() => {
                                  props.HandlePreviousPdf();
                                }}
                              >
                                <TbMathLower size="10px" />
                                <span className="content-buttons">
                                  Previous
                                </span>
                              </div>
                              <div className="line"></div>
                              <div
                                className={
                                  props?.currentIndex + 1 >= props?.data.length
                                    ? "next-video disable-color"
                                    : props?.data[props.currentIndex + 1]
                                        ?.lockStatus
                                    ? "next-video disable-color"
                                    : "next-video"
                                }
                                onClick={() => {
                                  const pdfDocumentContainer =
                                    document.getElementById("pdfDocument");
                                  if (pdfDocumentContainer) {
                                    pdfDocumentContainer.scrollTop = 0;
                                  }
                                  props.HandleNextpdf(
                                    props?.data[props?.currentIndex]?.id
                                  );
                                }}
                              >
                                <span
                                  className={
                                    props?.currentIndex + 1 >=
                                    props?.data.length
                                      ? "next-video disable-color"
                                      : props?.data[props.currentIndex + 1]
                                          ?.lockStatus
                                      ? "next-video disable-color"
                                      : "next-video"
                                  }
                                >
                                  Next
                                </span>
                                <TbMathGreater size="10px" />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="content-third-section">
                    <div className="content-title-heading">
                      {" "}
                      {satChapters?.length === 0 ? (
                        <>{props?.chapterName}</>
                      ) : (
                        <>{satChapters && satChapters[props?.chaptersCurrentIndex] ? satChapters[props?.chaptersCurrentIndex]?.title : ""}</>
                      )}
                      {props?.isNavigateBookmark ? (
                        <> {props?.chapterTitle}</>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="video-title-icon">
                      <>
                        <AiFillStar size="17px" fill="#FFAA00 " />
                        <span className="content-four-rating">
                          {" "}
                          {satCourseData && satCourseData[0]
                            ? (satCourseData[0]?.rating).toFixed(1)
                            : 0}
                        </span>
                      </>
                    </div>
                  </div>
                  {/* video paragraph section */}
                  <div className="content-fourth-section">
                    <div className="content-paragraph-title">
                      {props?.data[props?.currentIndex]?.title}
                    </div>
                    <div
                      id="pdfDocument"
                      className="scroll-container"
                      onScroll={(e) => {
                        props.handleScroll(e);
                      }}
                    >
                      <Document
                        file={props?.data[props?.currentIndex]?.pdfFileUrl}
                        onLoadSuccess={(pdf: any) => {
                          props.onDocumentLoadSuccess(pdf.numPages);
                        }}
                        onLoadError={() => {
                          console.log("Fail to load pdf");
                        }}
                      >
                        {props?.noOfPages && props.noOfPages.length > 0
                          ? props.noOfPages.map((subItem, idx) => {
                              return (
                                <Page key={idx} pageNumber={subItem} scale={1} />
                              );
                            })
                          : null}
                      </Document>
                    </div>
                  </div>
                  
                  <div>
                    {/* Mobile view  */}
                    {props.isNavigateBookmark ? (
                      ""
                    ) : (
                      <>
                        {props?.innerWidth < 1024 ? (
                          <>
                            <div className="responsive-panel">
                              <div
                                className={
                                  props?.currentIndex === 0 ||
                                  props?.checkPrevious
                                    ? "resp-previous-button change-resp-previous"
                                    : "resp-previous-button"
                                }
                                onClick={() => {
                                  props.HandlePreviousPdf();
                                }}
                              >
                                Previous
                              </div>

                              <div
                                className={
                                  props.currentIndex + 1 >= props.data.length
                                    ? "resp-previous-button m-l change-resp-next"
                                    : props.data[props.currentIndex + 1]
                                        .lockStatus
                                    ? "resp-previous-button  m-l change-resp-next"
                                    : "resp-previous-button  m-l"
                                }
                                onClick={() => {
                                  props.HandleNextpdf(
                                    props?.data[props?.currentIndex]?.id
                                  );
                                }}
                              >
                                Next
                              </div>
                            </div>
                            <div>
                              {props?.chapterCompleted ? (
                                <div className="content-chk-chapter">
                                  {" "}
                                  <div className="list-item-id-panel m-l">
                                    <FiLock size="15px" color="#ffff" />
                                  </div>
                                  Chapter will be unlock after 12
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default React.memo(Content);
